import { useEffect, useState } from 'react'
import useDataService from '../../hooks/useDataService'
import { object } from 'prop-types'
import { ListGroup } from 'react-bootstrap'
import Loader from './Loader'

const propTypes = {
  event: object.isRequired
}

const TopStringModels = ({ event }) => {
  const { apiGetMetrics } = useDataService()
  const [data, setData] = useState([])
  const [totals, setTotals] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    Promise.all([
      apiGetMetrics(event._id, 'string-model-stats'),
      apiGetMetrics(event._id, 'status-count')
    ]).then(([res1, res2]) => {
      setData(res1)
      setTotals(res2[0])
      setLoading(false)
    })
  }, [event])

  if (loading) {
    return <Loader />
  } else if (data?.length === 0 || !totals) {
    return (
    <div className='text-center'>
      <h5>Top string models</h5>
      No data to display
    </div>
    )
  }

  return (
    <div className='px-3'>
      <h5 className='text-center mb-2'>Top string models</h5>
      <div className='d-flex justify-content-between mx-2 text-body fw-bold mb-1'>
        <span>#</span>
        <span className='ms-1 me-auto'>Model name</span>
        <span>%</span>
      </div>
      <ListGroup as='ol' numbered>
          {data.map((s, i) => (
            <ListGroup.Item as='li' key={i} className='d-flex justify-content-between'>
              <span className='ms-1 me-auto'>{s._id}</span>
              {/* <span>{(s.total / totals.total * 100 / 4).toFixed()} %</span> */}
              <span>{(s.total / totals.total * 100 / 2).toFixed()} %</span>
            </ListGroup.Item>
          ))}
      </ListGroup>
    </div>
  )
}

TopStringModels.propTypes = propTypes

export default TopStringModels
